// extracted by mini-css-extract-plugin
export default {"page":"GP-z","cartModal":"HP-z","checkout":"IP-z","placeholder":"JP-z","account":"KP-z"};